const productAddWrapper = document.querySelector('[data-product-add-wrapper]')
const productLine = document.querySelector('.product-line')
if (productAddWrapper && productLine) {
  const submitButton = productAddWrapper.querySelector('button')
  const options = {
    threshold: 1.0
  }
  const callback = (entries) => {
    entries.forEach((entry) => {
      const state =
        !entry.isIntersecting &&
        window.scrollY > productAddWrapper.getBoundingClientRect().top
      productLine.classList.toggle('is-open', state)
    })
  }
  const observer = new IntersectionObserver(callback, options)
  observer.observe(productAddWrapper)

  const submitBridge = productLine.querySelector('[data-add-to-card-bridge]')
  if (submitButton && submitBridge) {
    submitBridge.addEventListener('click', (event) => {
      event.preventDefault()
      submitButton.click()
    })
  }
}
